import endpoints from '../endpoints.ts';
import { fetch } from './helpers.ts';

export namespace VerifiedTradingPartnerAPI {
  export namespace Response {
    export interface ReadOneIsAs2Active {
      verifiedTradingPartnerId: number;
      name: number;
      isAs2Active: boolean;
      hasActiveGlobalLocationNumber: boolean;
    }
  }
}

const verifiedTradingPartner = {
  read: {
    one: {
      isAs2Active: {
        by: {
          id: async (
            verifiedTradingPartnerId: number
          ): Promise<VerifiedTradingPartnerAPI.Response.ReadOneIsAs2Active | null> => {
            const url =
              endpoints.verifiedTradingPartner.read.one.isAs2Active.by.id();
            return await fetch<VerifiedTradingPartnerAPI.Response.ReadOneIsAs2Active>(
              url,
              'GET',
              {
                verifiedTradingPartnerId,
              }
            );
          },
        },
      },
    },
  },
};

export default verifiedTradingPartner;
